import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'primereact/button';

import PageHeader from '../components/PageHeader';
import Catalogue from '../components/Catalogue';
import Footer from '../components/Footer';
import TagPreview from '../components/TagPreview';
import { buildApiUrl } from '../utils/api';

export default function Projects () {
    const [data, setData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();
        const projectsEndpoint = buildApiUrl('/portfolio/');

        fetch(projectsEndpoint, { signal: controller.signal })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch portfolio: ${response.status}`);
                }

                return response.json();
            })
            .then((payload) => {
                const repoList = Array.isArray(payload)
                    ? payload
                    : Object.values(payload ?? {});

                const formatted = repoList.map((repo, index) => {
                    const tags = repo.tags ?? repo.topics ?? [];
                    const repoName = repo.name ?? repo.title ?? '';
                    const link = repo.link ?? repo.html_url ?? repo.homepage ?? repo.url ?? null;

                    return {
                        id: repo.id ?? `${repoName || 'repo'}-${index}`,
                        title: (repo.title ?? repoName) || 'Untitled Project',
                        tags,
                        tagsText: Array.isArray(tags) ? tags.join(' ') : '',
                        stars: repo.stars ?? repo.stargazers_count ?? 0,
                        link,
                        repoName,
                    };
                });

                setData(formatted);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error("Error fetching portfolio:", error);
                }
            });

        return () => controller.abort();
    }, []);

    const openProject = (repoName) => {
        if (!repoName) {
            return;
        }

        const encoded = encodeURIComponent(repoName);
        navigate(`/project/${encoded}`);
    };
    
    const projectColumns = [
        { field: 'title', header: 'Title', sortable: true, style: { width: '30%' } },
        { field: 'tagsText', header: 'Topics', bodyTemplate: rowData => <TagPreview tags={rowData.tags} />, style: { width: '40%' } },
        { field: 'stars', header: 'Stars', bodyTemplate: rowData => <p className='text-middle' style={{ color: "#e4b340" }}><i className='pi pi-star-fill'></i> {rowData.stars.toLocaleString()}</p>, sortable: true, style: { width: '15%' } },
        { field: 'link', header: 'Link', bodyTemplate: rowData => <Button label="Open" icon="pi pi-external-link" outlined rounded className="p-button-text" size='small' onClick={() => openProject(rowData.repoName)} />, style: { width: '15%' } }
    ];

    return (
        <div className="projects card">
            <PageHeader data={
                {
                    header: 'Projects',
                    emoji: '🙌',
                    subheading: 'A portfolio of hands-on projects that blend software development, data engineering, and AI to create impactful and scalable solutions.'
                }
            } />
            <Catalogue data={data} columns={projectColumns} filterFields={['title', 'tagsText']} selectedFields={['title', 'tagsText', 'stars', 'link']} />
            <Footer />
        </div>
    );
};
